import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    ConfigurationShelfSampleTypeAssignmentCreateRequest,
    ConfigurationShelfSampleTypeAssignmentPatchInBatchRequest,
    ConfigurationShelfSampleTypeAssignmentResponse
} from '@/modules/configurationModule/detail/automation/grossing-shelf/sample-type-and-shelf/services/configuration-shelf-sample-type-assignment/configuration-shelf-sample-type-assignment.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationShelfSampleTypeAssignmentService {
    async create(laboratoryId: number, request: ConfigurationShelfSampleTypeAssignmentCreateRequest): Promise<ConfigurationShelfSampleTypeAssignmentResponse> {
        const response = await axios.post<ConfigurationShelfSampleTypeAssignmentResponse>(`/configuration/laboratories/${laboratoryId}/shelfSampleTypeAssignment`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationShelfSampleTypeAssignmentResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationShelfSampleTypeAssignmentResponse>>(`/configuration/laboratories/${laboratoryId}/shelfSampleTypeAssignment`, { ...filterModel }, { params })
        return response.data
    }

    async get(shelfSampleTypeAssignmentId: number, laboratoryId: number): Promise<ConfigurationShelfSampleTypeAssignmentResponse> {
        const response = await axios.get<ConfigurationShelfSampleTypeAssignmentResponse>(`/configuration/laboratories/${laboratoryId}/shelfSampleTypeAssignment/${shelfSampleTypeAssignmentId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/shelfSampleTypeAssignment/batch`, { data: request })
        return response.data
    }

    async patch(laboratoryId: number, request: ConfigurationShelfSampleTypeAssignmentPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/shelfSampleTypeAssignment/batch`, request)
        return response.data
    }
}

export const configurationShelfSampleTypeAssignmentService = new ConfigurationShelfSampleTypeAssignmentService()
